import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import NumberFormat from "react-number-format";
import { Tabs, TabList, Tab } from "react-tabs";
import { Button, Select } from "antd";
import Swal from "sweetalert2";
export class ReViewTakeMoney extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Amount: 0,
      balanceRemian: 0,
      currency: "",
      Money_provider: "",
      Money_recive: "",
      from: "",
      to: "",
      type:
        this.props.lang === "en"
          ? "Monthly rent invoice"
          : this.props.lang === "krd"
          ? "کرێی مانگانە"
          : "فواتير الإيجار الشهري",
      save: null,
      instead_of: "",
      R_cursor: 0,
      List_names: [],
      tid: "",
      pedraw: "",
      updated: false,
      // new states
      property: "",
      place: "",
      num: "",
      note: "",
      box_status: "",
      createdAt: "",
    };
  }
  componentDidMount() {
    const { Get_List_Agents } = this.props;
    Get_List_Agents();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.parawargrtn_view !== this.props.parawargrtn_view) {
      this.setState({
        Amount: this.props.parawargrtn_view.Amount,
        currency: this.props.parawargrtn_view.currency,
        Money_provider: this.props.parawargrtn_view.Money_provider,
        Money_recive: this.props.parawargrtn_view.Money_recive,
        from: this.props.parawargrtn_view.from,
        to: this.props.parawargrtn_view.to,
        type: this.props.change_Lang(this.props.parawargrtn_view.type),
        instead_of: this.props.parawargrtn_view.instead_of,
        pedraw: this.props.parawargrtn_view.pedraw,
        updated: true,
        balanceRemian: this.props.parawargrtn_view.balanceRemian,
        place: this.props.parawargrtn_view.place,
        note: this.props.parawargrtn_view.note,
        property: this.props.parawargrtn_view.property,
        num: this.props.parawargrtn_view.num,
        box_status: this.props.parawargrtn_view.box_status,
        createdAt: this.props.parawargrtn_view.createdAt,
      });
    }
  }
  OnChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onOpenUpdate = async () => {
    this.setState({ updated: false });
  };

  onCloseUpdate = () => {
    const data = {
      Money_provider: this.state.Money_provider,
      Money_recive: this.state.Money_recive,
      Amount: parseFloat(this.state.Amount.toString().replace(/,/g, "")),
      balanceRemian: parseFloat(
        this.state.balanceRemian.toString().replace(/,/g, "")
      ),
      from: this.state.from,
      to: this.state.to,
      currency: this.props.EveryTimeTo_English(this.state.currency),
      type: this.props.EveryTimeTo_English(this.state.type),
      instead_of: this.state.instead_of,
      pedraw: this.state.pedraw,
      note: this.state.note,
      property: this.state.property,
      place: this.state.place,
      num: this.state.num,
      box_status: this.state.box_status,
      createdAt: this.state.createdAt,
    };
    if (
      this.state.Money_provider === "" ||
      this.state.Amount === "" ||
      this.state.Amount === 0 ||
      this.state.type === "" ||
      this.state.currency.toString().length === 0 ||
      this.state.createdAt === "" ||
      this.state.box_status.toString().length === 0
    ) {
      Swal.fire({
        title: "OPS",
        text: this.props.change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${this.props.change_Lang(
          "Please Check Inputs"
        )}</b>`,
        confirmButtonText: this.props.change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${this.props.change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: this.props.change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      this.props.Update_TakeMoney(this.props.parawargrtn_view._id, data);
      this.props.handleCancel();
      this.setState({ updated: true });
    }
  };
  onselect = (index) => {
    if (index === 0) {
      let type =
        this.props.lang === "en"
          ? "Monthly rent invoice"
          : this.props.lang === "krd"
          ? "کرێی مانگانە"
          : "فواتير الإيجار الشهري";
      this.setState({
        type: type,
      });
    } else if (index === 1) {
      let type =
        this.props.lang === "en"
          ? "Service Bill"
          : this.props.lang === "krd"
          ? "خزمەتگوزاری"
          : "فواتير الخدمات";
      this.setState({
        type: type,
      });
    } else if (index === 2) {
      let type =
        this.props.lang === "en"
          ? "Insurance Bill"
          : this.props.lang === "krd"
          ? "دڵنیایی"
          : "التأمين";
      this.setState({
        type: type,
      });
    } else if (index === 3) {
      let type =
        this.props.lang === "en"
          ? "Sell"
          : this.props.lang === "krd"
          ? "فرۆشتن"
          : "بيع";
      this.setState({
        type: type,
      });
    } else if (index === 4) {
      let type =
        this.props.lang === "en"
          ? "Buy"
          : this.props.lang === "krd"
          ? "کڕین"
          : "شراء";
      this.setState({
        type: type,
      });
    } else if (index === 5) {
      let type =
        this.props.lang === "en"
          ? "Arabun"
          : this.props.lang === "krd"
          ? "عربون"
          : "عربون";
      this.setState({
        type: type,
      });
    } else if (index === 6) {
      let type =
        this.props.lang === "en"
          ? "comision"
          : this.props.lang === "krd"
          ? "عمولە"
          : "عمولة";
      this.setState({
        type: type,
      });
    } else if (index === 7) {
      let type =
        this.props.lang === "en"
          ? "investor"
          : this.props.lang === "krd"
          ? "وەبەرهێنەر"
          : "مستثمر";
      this.setState({
        type: type,
      });
    }
  };
  Print = () => {
    window.setTimeout(function () {
      window.print();
    }, 6000);
  };
  handleChange_Property = (value) => {
    this.setState({ property: value });
  };
  render() {
    const { change_Lang, parawargrtn_view, lang, list_agents } = this.props;
    const {
      Money_provider,
      Money_recive,
      from,
      to,
      Amount,
      updated,
      currency,
      note,
      place,
      num,
      property,
      instead_of,
      type,
      box_status,
      createdAt,
    } = this.state;
    const { OnChangeHandler, onOpenUpdate } = this;
    const { Option } = Select;
    const list_agents_map = list_agents.map((el, key) => {
      return <option key={key}>{`${el.fname} ${el.lname}`}</option>;
    });
    return (
      <Fragment>
        <Tabs onSelect={(index) => this.onselect(index)}>
          <div
            className={`${
              lang === "en" ? "container-fluid" : "container-fluid fk"
            }`}
          >
            <div className="row">
              <div className="col-md-4 d-flex justify-content-start">
                <label
                  style={{ fontSize: "22px", color: "#295a68" }}
                  className="product-page-details product-right mb-2 text-uppercase font-weight-bold"
                >
                  {change_Lang("Taj Emara Real Estate")}
                </label>
              </div>

              <div className="col-md-4 d-flex justify-content-center">
                <label
                  style={{
                    fontWeight: "bold",
                    color: "#295a68",
                    fontSize: "30px",
                  }}
                  className="product-page-details product-right mb-2 text-uppercase font-weight-bold"
                >
                  {change_Lang("Repayment bills")}
                </label>
              </div>
              <div className="col-md-4 d-flex justify-content-end">
                <div className="product-price digits form-group row">
                  <div className="col-sm-4">
                    <label
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#295a68",
                      }}
                      className=" col-form-label fk"
                    >
                      {change_Lang("date")}:
                    </label>
                  </div>
                  <div className="col-sm-8 d-flex justify-content-start text-right">
                    {updated !== false ? (
                      <Time
                        value={parawargrtn_view && parawargrtn_view.createdAt}
                        format="YYYY-MM-DD"
                        style={{
                          color: "#295a68",
                          fontSize: "18px",
                          fontWeight: "bold",
                          border: "none",
                        }}
                        className="form-control fk d-flex justify-content-satrt text-right mt-1"
                      />
                    ) : (
                      <input
                        type="date"
                        className="form-control"
                        value={createdAt}
                        name="createdAt"
                        onChange={OnChangeHandler}
                        autoComplete="off"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#3889c1",
                        }}
                      />
                    )}
                  </div>
                </div>
                {/*  */}
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12">
                  {updated !== false ? (
                    <TabList
                      style={{
                        background: "white",
                        fontSize: "20px",
                      }}
                      className={`${
                        lang === "en"
                          ? "nav nav-tabs tab-coupon d-flex justify-content-center"
                          : "nav nav-tabs tab-coupon d-flex justify-content-center fk"
                      }`}
                    >
                      {parawargrtn_view &&
                      change_Lang(parawargrtn_view.type) ===
                        change_Lang("Monthly rent invoice") ? (
                        <Tab
                          value={change_Lang("Monthly rent invoice")}
                          className="nav-link"
                        >
                          {change_Lang("Monthly rent invoice")}
                        </Tab>
                      ) : parawargrtn_view &&
                        change_Lang(parawargrtn_view.type) ===
                          change_Lang("Service Bill") ? (
                        <Tab className="nav-link">
                          {change_Lang("Service Bill")}
                        </Tab>
                      ) : parawargrtn_view &&
                        change_Lang(parawargrtn_view.type) ===
                          change_Lang("Buy_Required_translation") ? (
                        <Tab className="nav-link">
                          {change_Lang("Buy_Required_translation")}
                        </Tab>
                      ) : parawargrtn_view &&
                        change_Lang(parawargrtn_view.type) ===
                          change_Lang("Sell") ? (
                        <Tab className="nav-link">{change_Lang("Sell")}</Tab>
                      ) : parawargrtn_view &&
                        change_Lang(parawargrtn_view.type) ===
                          change_Lang("Arabun") ? (
                        <Tab className="nav-link">{change_Lang("Arabun")}</Tab>
                      ) : parawargrtn_view &&
                        change_Lang(parawargrtn_view.type) ===
                          change_Lang("comision") ? (
                        <Tab className="nav-link">
                          {change_Lang("comision")}
                        </Tab>
                      ) : parawargrtn_view &&
                        change_Lang(parawargrtn_view.type) ===
                          change_Lang("investor") ? (
                        <Tab className="nav-link">
                          {change_Lang("investor")}
                        </Tab>
                      ) : (
                        <Tab className="nav-link">
                          {change_Lang("Insurance Bill")}
                        </Tab>
                      )}
                    </TabList>
                  ) : (
                    <TabList
                      style={{ background: "white" }}
                      className={`${
                        lang === "en"
                          ? "nav nav-tabs tab-coupon d-flex justify-content-center"
                          : "nav nav-tabs tab-coupon d-flex justify-content-center fk"
                      }`}
                    >
                      <Tab
                        value={change_Lang("Monthly rent invoice")}
                        className="nav-link"
                      >
                        {change_Lang("Monthly rent invoice")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("Service Bill")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("Insurance Bill")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("Sell")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("Buy_Required_translation")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("Arabun")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("comision")}
                      </Tab>
                      <Tab className="nav-link" onChange={OnChangeHandler}>
                        {change_Lang("investor")}
                      </Tab>
                    </TabList>
                  )}
                </div>
              </div>
              <div className="row mb-4 ">
                <div className="col-sm-6  ">
                  <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                    <div className="col-sm-4">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("received from Mr")}:
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <input
                        value={Money_provider}
                        name="Money_provider"
                        onChange={OnChangeHandler}
                        disabled={updated !== false ? true : false}
                        autoComplete="off"
                        className="form-control fk text-center"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#3889c1",
                        }}
                      />
                    </div>
                  </div>
                  <div className="product-price digits mt-2 form-group row ">
                    <div className="col-sm-4 ">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("such_as")}:
                      </label>
                    </div>
                    <div className="col-sm-8 ">
                      {/* karwan */}
                      {type !== change_Lang("investor") ? (
                        <>
                          {this.state.type !==
                          change_Lang("Monthly rent invoice") ? (
                            <>
                              <div className="row">
                                <div className="col-sm-6">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={this.state.type}
                                    autoComplete="off"
                                    disabled={true}
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6 ">
                                  <Select
                                    onChange={this.handleChange_Property}
                                    value={property}
                                    disabled={updated !== false ? true : false}
                                    defaultValue={change_Lang("Choose")}
                                    className="fk col-12 text-center"
                                    size="large"
                                    style={{
                                      fontSize: "16px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  >
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value=""
                                    >
                                      {change_Lang("Choose")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Apartment"
                                    >
                                      {change_Lang("Apartment")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="House"
                                    >
                                      {change_Lang("House")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Farm"
                                    >
                                      {change_Lang("Farm")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Shop"
                                    >
                                      {change_Lang("Shop")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Vella"
                                    >
                                      {change_Lang("Vella")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Earth"
                                    >
                                      {change_Lang("Earth")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Strecture"
                                    >
                                      {change_Lang("Strecture")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Commercial Land"
                                    >
                                      {change_Lang("Commercial Land")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Company"
                                    >
                                      {change_Lang("Company")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Hotel"
                                    >
                                      {change_Lang("Hotel")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Car Garage"
                                    >
                                      {change_Lang("Car Garage")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Stadium"
                                    >
                                      {change_Lang("Stadium")}
                                    </Option>
                                  </Select>
                                </div>
                                <br />
                                <br />
                                <div className="col-sm-6">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={place}
                                    name="place"
                                    onChange={OnChangeHandler}
                                    disabled={updated !== false ? true : false}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>

                                <div className="col-sm-6 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={num}
                                    name="num"
                                    onChange={OnChangeHandler}
                                    disabled={updated !== false ? true : false}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                    title="ok"
                                  />
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="row">
                                <div className="col-sm-6">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={this.state.type}
                                    disabled={true}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6">
                                  <Select
                                    onChange={this.handleChange_Property}
                                    value={property}
                                    defaultValue={change_Lang("Choose")}
                                    className="fk col-12 text-center"
                                    disabled={updated !== false ? true : false}
                                    size="large"
                                    style={{
                                      fontSize: "16px",
                                      borderBottomColor: "#295a68",
                                      fontWeight: "bolder",
                                      color: "black",
                                    }}
                                  >
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value=""
                                    >
                                      {change_Lang("Choose")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Apartment"
                                    >
                                      {change_Lang("Apartment")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="House"
                                    >
                                      {change_Lang("House")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Farm"
                                    >
                                      {change_Lang("Farm")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Shop"
                                    >
                                      {change_Lang("Shop")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Vella"
                                    >
                                      {change_Lang("Vella")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Earth"
                                    >
                                      {change_Lang("Earth")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Strecture"
                                    >
                                      {change_Lang("Strecture")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Commercial Land"
                                    >
                                      {change_Lang("Commercial Land")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Company"
                                    >
                                      {change_Lang("Company")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Hotel"
                                    >
                                      {change_Lang("Hotel")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Car Garage"
                                    >
                                      {change_Lang("Car Garage")}
                                    </Option>
                                    <Option
                                      className="fk"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                      value="Stadium"
                                    >
                                      {change_Lang("Stadium")}
                                    </Option>
                                  </Select>
                                </div>
                                <br />
                                <br />
                                <div className="col-sm-6 ">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={place}
                                    name="place"
                                    onChange={OnChangeHandler}
                                    disabled={updated !== false ? true : false}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6">
                                  <input
                                    type="text"
                                    className="form-control fk"
                                    value={num}
                                    name="num"
                                    onChange={OnChangeHandler}
                                    disabled={updated !== false ? true : false}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>
                                <br />
                                <br />
                                {/* felo */}
                                <div className="col-sm-6">
                                  <input
                                    type="date"
                                    className="form-control fk"
                                    value={from}
                                    name="from"
                                    onChange={OnChangeHandler}
                                    disabled={updated !== false ? true : false}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>
                                <div className="col-sm-6">
                                  <input
                                    type="date"
                                    className="form-control fk"
                                    value={to}
                                    name="to"
                                    onChange={OnChangeHandler}
                                    disabled={updated !== false ? true : false}
                                    autoComplete="off"
                                    style={{
                                      fontSize: "17px",
                                      borderBottomColor: "#295a68",
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <input
                          type="text"
                          className="form-control fk"
                          value={instead_of}
                          name="instead_of"
                          onChange={OnChangeHandler}
                          disabled={updated !== false ? true : false}
                          autoComplete="off"
                          style={{
                            fontSize: "17px",
                            borderBottomColor: "#295a68",
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="product-price digits mt-2 form-group row ">
                    <div className="col-sm-4 ">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("Name of the recipient")}:
                      </label>
                    </div>
                    <div className="col-sm-8 ">
                      {updated !== false ? (
                        <input
                          type="text"
                          className="form-control fk text-center"
                          value={Money_recive}
                          autoComplete="off"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        />
                      ) : box_status !== "off" ? (
                        <select
                          value={Money_recive}
                          className="form-control  d-flex justify-content-start fk"
                          onChange={OnChangeHandler}
                          name="Money_recive"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#295a68",
                          }}
                        >
                          <option value="">--{change_Lang("Choose")}--</option>
                          {list_agents_map}
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-control fk text-center"
                          value={Money_recive}
                          autoComplete="off"
                          name="Money_recive"
                          onChange={OnChangeHandler}
                          disabled={updated !== false ? true : false}
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <br />
                <div className="col-sm-6 ">
                  <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                    <div className="col-sm-4">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("money")}:
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <NumberFormat
                        displayType={`${updated !== true ? "input" : "text"}`}
                        thousandSeparator={true}
                        name="Amount"
                        onChange={OnChangeHandler}
                        disabled={updated !== false ? true : false}
                        value={Amount}
                        required
                        className="form-control fk text-center"
                        prefix={
                          updated !== true
                            ? ""
                            : currency !== "dolar"
                            ? "ID"
                            : "$"
                        }
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#3889c1",
                        }}
                      />
                    </div>
                  </div>
                  <div className="product-price digits form-group row">
                    <div className="col-sm-4">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("Currency Type")}:
                      </label>
                    </div>
                    <div className="col-sm-8 d-flex justify-content-start text-right">
                      {updated !== false ? (
                        <input
                          value={change_Lang(currency)}
                          className="form-control fk text-center"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        />
                      ) : (
                        <select
                          value={currency}
                          className="form-control  d-flex justify-content-start fk"
                          onChange={OnChangeHandler}
                          name="currency"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        >
                          <option value="">--{change_Lang("Choose")}--</option>
                          <option value="dolar">{change_Lang("dolar")}</option>
                          <option value="dinar">{change_Lang("dinar")}</option>
                        </select>
                      )}
                    </div>
                  </div>
                  <div className="product-price digits form-group row">
                    <div className="col-sm-4">
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("Does the money go into the box?")}:
                      </label>
                    </div>
                    <div className="col-sm-8 d-flex justify-content-start text-right">
                      {updated !== false ? (
                        <input
                          value={
                            box_status !== "off"
                              ? change_Lang("Yes")
                              : change_Lang("No")
                          }
                          className="form-control fk text-center"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        />
                      ) : (
                        <select
                          value={box_status}
                          className="form-control  d-flex justify-content-start fk"
                          onChange={OnChangeHandler}
                          name="box_status"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#3889c1",
                          }}
                        >
                          <option value="">{change_Lang("Choose")}</option>
                          <option value="on">{change_Lang("Yes")}</option>
                          <option value="off">{change_Lang("No")}</option>
                        </select>
                      )}
                    </div>
                  </div>
                  {/* notes */}
                  <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                    <div className="col-sm-4">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("note")}:
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <input
                        value={note}
                        name="note"
                        onChange={OnChangeHandler}
                        disabled={updated !== false ? true : false}
                        autoComplete="off"
                        className="form-control fk text-center"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#3889c1",
                        }}
                      />
                    </div>
                  </div>
                  <div className="product-price digits mt-2 form-group row ">
                    <div className="col-sm-4 ">
                      <label
                        style={{
                          fontSize: "18px",
                          color: "#295a68",
                          fontWeight: "bold",
                        }}
                        className=" col-form-label fk"
                      >
                        {change_Lang("Name of Branch")}:
                      </label>
                    </div>
                    <div className="col-sm-8 ">
                      <input
                        type="text"
                        className="form-control fk text-center"
                        value={
                          parawargrtn_view ? parawargrtn_view.branchId.name : ""
                        }
                        autoComplete="off"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#3889c1",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center">
                  {updated !== false ? (
                    <Button
                      className="fk px-4"
                      type="primary"
                      shape="round"
                      style={{
                        background: "#d7e4eb",
                        color: "#4b85a4",
                        border: "none",
                        outline: "none",
                      }}
                      htmlType="submit"
                      onClick={onOpenUpdate}
                    >
                      {change_Lang("profile_updatebt")}&nbsp;
                      <i
                        className="fa fa-lock"
                        style={{ fontSize: "14px" }}
                      ></i>
                    </Button>
                  ) : (
                    <Button
                      className="fk px-4"
                      type="primary"
                      shape="round"
                      style={{
                        background: "#d7e4eb",
                        color: "#4b85a4",
                        border: "none",
                        outline: "none",
                      }}
                      htmlType="submit"
                      onClick={this.onCloseUpdate}
                    >
                      {change_Lang("profile_updatebt")}&nbsp;
                      <i
                        className="fa fa-lock-open"
                        style={{ fontSize: "14px" }}
                      ></i>
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Tabs>
      </Fragment>
    );
  }
}

export default ReViewTakeMoney;
